import { IProductDelivery } from 'types/orders';

export const extractProductData = (products: IProductDelivery[]) => {
  return products?.map(({ id, serial, saleId }) => ({
    productId: id,
    serial: serial ?? '',
    saleId
  }));
};
